<template>
  <div id="sovindia4page">
    <div
      data-html2canvas-ignore="true"
      class="customdim"
      v-show="loader || loader0 || loader4"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.pStartDate"
          />
        </div>
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.startDate"
          />
        </div>
        <div class="datebox">
          <select
            @change="refresh0"
            v-model="selected_website"
            class="form-control text-uppercase"
          >
            <option value="https://www.amazon.in">Amazon</option>
            <option value="https://www.flipkart.com">Flipkart</option>
          </select>
        </div>
        <div class="datebox" style="width: 18%">
          <select
            @change="icChanged"
            v-model="selectedItemCategory"
            class="form-control text-uppercase"
          >
            <option v-for="d in itemCategory" :value="d" :key="d.key">
              {{ d.value }}
            </option>
          </select>
        </div>

        <div class="datebox">
          <button @click="icChanged" class="btn btn-block weavrpurple" type="button">
            <span style="font-size: 13px">Submit</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-4" style="padding-right: 2px">
          <div class="card">
            <div style="margin: 0" class="space-between-header">
              <p style="margin: 0; padding-bottom: 0 !important" class="p-2">
                SOV {{ selectedItemCategory.value }} Category
              </p>
            </div>
            <highcharts :options="charts" v-if="activeChart"></highcharts>
          </div>
        </div>
        <div class="col-md-4" style="padding-left: 2px; padding-right: 2px">
          <div class="card">
            <div style="margin: 0" class="space-between-header">
              <p style="margin: 0; padding-bottom: 0 !important" class="p-2">
                SOV {{ selectedItemCategory.value }} Search
              </p>
            </div>
            <highcharts :options="charts_sos" v-if="activeChart"></highcharts>
          </div>
        </div>

        <div class="col-sm-4 mycols">
          <div class="card">
            <div style="margin: 0" class="space-between-header">
              <p style="margin: 0; padding-bottom: 0 !important" class="p-2">
                SOV Position on Page
              </p>
            </div>
            <highcharts
              :options="categorySearchGraph"
              v-if="activecategorySearchGraph"
            ></highcharts>
          </div>
        </div>
      </div>

      <div class="space-between-header">
        <h4>SOV trend for {{ selectedItemCategory.value }} category pages (1-4)</h4>
        <div>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group
              class="radiohide"
              id="radiosBtn"
              buttons
              button-variant="outline-secondary"
              v-model="sovInterval"
              name="radiosBtn"
            >
              <b-form-radio class="mx-0" value="day">Day</b-form-radio>
              <b-form-radio class="mx-0" value="week">Week</b-form-radio>
              <b-form-radio class="mx-0" value="month">Month</b-form-radio>
            </b-form-radio-group>
            <button
              style="
                margin-left: 6px;
                height: 30px;
                border: none;
                background: #8a87e8;
                color: white;
              "
            >
              From
            </button>
            <datepicker
              @input="changeSOVandTrendDate"
              placeholder="From"
              v-model="sovStartDate"
            />
            <button
              style="
                margin-left: 6px;
                height: 30px;
                border: none;
                background: #8a87e8;
                color: white;
              "
            >
              To
            </button>
            <datepicker
              @input="changeSOVandTrendDate"
              class="picker-left"
              placeholder="To"
              v-model="sovEndDate"
            />
          </b-button-toolbar>
        </div>
      </div>
      <div class="card p-2">
        <highcharts style="width: 100%" :options="daywiseChart"></highcharts>
      </div>
      <div>
        <div class="space-between-header">
          <h4>Trend for Hindware {{ selectedItemCategory.value }} count</h4>
        </div>
        <div class="card p-2">
          <highcharts style="width: 100%" :options="daywiseAMDCount"></highcharts>
        </div>
      </div>
      <div>
        <div class="space-between-header">
          <h3></h3>
          <div style="display: inherit">
            <div
              @click="showProductModal"
              style="display: flex; cursor: pointer; text-transform: capitalize"
            >
              <div
                style="
                  padding: 5px;
                  height: 30px;
                  border: none;
                  background: #8a87e8;
                  color: white;
                "
              >
                Products
              </div>
              <div
                style="
                  background: white;
                  padding-left: 14px;
                  padding-right: 14px;
                  font-size: 12px;
                  padding-top: 8px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 214px;
                "
              >
                <span v-if="selectedProduct">{{ selectedProduct.toUpperCase() }} </span>
              </div>
            </div>
            <div
              style="
                margin-left: 6px;
                padding: 5px;
                height: 30px;
                border: none;
                background: #8a87e8;
                color: white;
              "
            >
              From
            </div>
            <datepicker
              placeholder="From"
              @input="refreshReview"
              v-model="reviewStartDate"
            />
            <div
              style="
                margin-left: 6px;
                padding: 5px;
                height: 30px;
                border: none;
                background: #8a87e8;
                color: white;
              "
            >
              To
            </div>
            <datepicker
              v-model="reviewEndDate"
              class="picker-left"
              placeholder="To"
              @input="refreshReview"
            />
            <div
              @click="goToReview"
              class="sovdetails listing-custom badge badge-primary"
            >
              Show Reviews
            </div>
          </div>
        </div>
        <div class="card p-2" style="margin-bottom: 4px">
          <div class="space-between-header">
            <h4>Total Reviews: {{ totalReviewCount | format }}</h4>
            <div>
              <b-button-toolbar
                class="float-right"
                aria-label="Toolbar with buttons group"
              >
                <b-form-radio-group
                  class="radiohide"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="revInterval"
                  name="radiosBtn"
                >
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </div>
          </div>
          <highcharts
            :options="reviewGraph"
            v-if="activeReviewGraph && !loader"
          ></highcharts>
          <div style="margin: 15px"></div>
          <highcharts
            :options="creviewGraph"
            v-if="activeReviewGraph && !loader"
          ></highcharts>
        </div>
        <div class="card p-2" v-if="!loader">
          <div class="space-between-header">
            <h4>Avg. Rating: {{ ratingAvg }}</h4>
            <div style="display: flex">
              <b-button-toolbar aria-label="Toolbar with buttons group">
                <b-form-radio-group
                  class="radiohide"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="revInterval"
                  name="radiosBtn"
                >
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </div>
          </div>
          <highcharts :options="ratingGraph" v-if="activeRatingGraph"></highcharts>
          <div style="margin: 15px"></div>
          <highcharts :options="cratingGraph" v-if="activeReviewGraph"></highcharts>
          <p style="text-align: center; font-size: 12px; text-transform: initial">
            Cumulative Rating = Cumulative Sum of Ratings / Cumulative Sum of Reviews
          </p>
        </div>
      </div>
      <div class="space-between-header">
        <h3>{{ selectedItemCategory.value }} Category Data</h3>
        <div>
          <span style="line-height: 31px; margin-right: 10px">Pages:</span>
          <select
            @change="changeCategory"
            v-model="dataType"
            class="form-control text-uppercase"
          >
            <option value="category">Category</option>
            <option value="search">Search</option>
          </select>
          <select
            @change="getPie"
            style="margin-right: 10px"
            v-model="selectedPage"
            class="form-control text-uppercase"
          >
            <option value="1">1</option>
            <option value="1-4">1-4</option>
          </select>
        </div>
      </div>
      <div class="">
        <h4 style="display: inline-block">{{ selectedItemCategory.value }} Listing</h4>
        <div
          @click="goToDetailPage"
          class="sovdetails listing-custom badge badge-primary"
        >
          Show Details
        </div>
        <div class="row">
          <div class="col-sm-12 mycol">
            <div class="card">
              <highcharts style="width: 100%" :options="pieChartAMD"></highcharts>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 mycol">
          <div class="card p-2">
            <div class="custom-hr-scroll">
              <table>
                <tbody>
                  <tr style="border: 1px solid silver" v-for="d of report" :key="d.key">
                    <td class="tr" style="min-width: 150px">
                      <div style="text-align: left">
                        <span style="display: inline-block; padding-left: 5px"
                          >{{ d.label }}
                        </span>
                      </div>
                    </td>
                    <td
                      class="tr bg-white text-dark"
                      style="width: 300px"
                      v-for="(row, i) in viewTableDataSummary[d.key]"
                      :key="i"
                    >
                      <div style="display: flex; justify-content: center; height: 200px">
                        <div style="height: 150px; text-align: center">
                          <img
                            :src="row.image_url"
                            style="height: 100%"
                            class="img-fluid"
                          />
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <span style="padding-left: 5px; color: grey"
                          >Reviews: {{ row.reviews }}</span
                        >
                        <span style="padding-right: 5px; color: grey"
                          >Ratings: {{ row.ratings }}</span
                        >
                      </div>
                      <a
                        style="text-align: left"
                        class="text-dark"
                        target="_blank"
                        :href="row.link"
                      >
                        <span
                          style="
                            padding-left: 5px;
                            display: inline-block;
                            font-weight: 500;
                            height: 90px;
                          "
                          >{{ row.name }}
                        </span>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      body-class="modal-body-custom"
      size="lg"
      title="Select Product"
      v-model="isProductModal"
      style="background: whitesmoke"
    >
      <div style="position: relative">
        <input
          style="padding-left: 30px; border-radius: 0"
          class="form-control"
          v-model="schProduct"
          type="text"
          placeholder="Search Product"
        />
        <i
          style="position: absolute; left: 0; top: 0; padding: 10px"
          class="fa fa-search"
        ></i>
      </div>
      <b-row class="pt-2 mt-3">
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-3">
              <p style="margin-bottom: 0; padding: 7px">Brand</p>
            </div>
            <div class="col-md-9">
              <select
                @change="getProduct"
                v-model="selectedFilterBrand"
                style="text-transform: uppercase"
                class="form-control"
              >
                <option value="">All</option>
                <option v-for="d in filterBrand" :value="d">{{ d }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2">
              <p style="margin-bottom: 0; padding: 7px">Category</p>
            </div>
            <div class="col-md-6">
              <select
                @change="getProduct"
                v-model="selectedFilterCategory"
                style="text-transform: uppercase"
                class="form-control fluid"
              >
                <option value="">All</option>
                <option v-for="d in filterCategory" :value="d.key">{{ d.value }}</option>
              </select>
            </div>
          </div>
        </div>
      </b-row>
      <div
        style="
          background: white;
          margin-top: 20px;
          cursor: pointer;
          height: 300px;
          overflow-y: scroll;
        "
      >
        <div
          class="eachProduct"
          @click="selectProductNow('all')"
          style="padding: 4px; border-bottom: 1px solid #e6e6e6"
        >
          All
        </div>
        <div
          :class="{ selectedProduct: selectedProduct == d }"
          v-if="d.toLowerCase().indexOf(schProduct.toLowerCase()) != -1"
          class="eachProduct"
          @click="selectProductNow(d)"
          style="
            padding: 4px;
            border-bottom: 1px solid #e6e6e6;
            text-transform: capitalize;
          "
          v-for="d in productOptions"
        >
          {{ d.toUpperCase() }}
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "sovindia4page",
  components: { Datepicker },
  data: function () {
    return {
      selected_website: "https://www.amazon.in",
      date: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        // startDate: "2022-03-01",
        pStartDate: moment("2022-09-01").format("YYYY-MM-DD"),
        disabled: {
          pstart: {
            to: "",
            from: moment("2022-03-01").toDate(),
          },
          start: {
            to: moment("2022-02-21").toDate(),
            from: moment("2022-03-01").toDate(),
          },
        },
      },
      moment: moment,
      websitesUrls: {
        "https://www.amazon.in": "amazon",
        "https://www.flipkart.com": "flipkart",
      },
      columns: [
        { label: "Brand", field: "brand", sortable: false },
        { label: "Sub Brand", field: "sub_brand", sortable: false },
        { label: "Form Factor", field: "form_factor", sortable: false },
        { label: "Page 1 System Count", field: "page_1_system_count" },
        { label: "Page Count (page 1)", field: "page_1_count" },
        { label: "Page 1 SOV", field: "page_1_sov" },

        { label: "Pages 1-4 System Count", field: "page_1_3_system_count" },
        { label: "Pages Count (1-4)", field: "page_1_3_count" },
        { label: "Pages 1-4 SOV", field: "page_1_3_sov" },

        { label: "All Pages System Count", field: "page_all_system_count" },
        { label: "All Pages Count", field: "page_all_count" },
        { label: "All Pages SOV", field: "page_all_sov" },
      ],
      rows: [],
      sos_rows: [],
      rows_details: [],
      page: 1,
      charts: {},
      charts_sos: {},
      activeChart: false,
      labelMapper: {
        brand: "Brand",
        processor_type: "Processor",
        // 'gpu_type': 'GPU'
      },
      isProductModal: false,

      countAMD: {},
      pieChartAMD: {},
      barGraph: {},
      activePie: false,
      activeBarChart: false,
      selectedPage: "1-4",
      loader: true,
      loader0: false,
      pageDistributionData: {},
      sovSOSGraph: {},
      activesovSOSGraph: true,
      categorySearchGraph: {},
      activecategorySearchGraph: true,
      daywiseChartAverage: {},
      daywiseAMDCount: {},
      colorShades: {
        red: [
          "#f56464",
          "#fb7878",
          "#fb9178",
          "#fbc778",
          "#f57264",
          "#f56485",
          "#f56492",
        ],
        blue: [
          "#7887fb",
          "#788dfb",
          "#78a6fb",
          "#78b2fb",
          "#78d0fb",
          "#78d6fb",
          "#78c4fb",
        ],
        green: [
          "#9af575",
          "#87d866",
          "#80f564",
          "#9bf564",
          "#64f591",
          "#64f570",
          "#71b755",
        ],
      },
      index: {
        red: 0,
        blue: 0,
        green: 0,
      },
      daywiseChart: {},
      dailyData: [],
      amdCPUFilter: "all",
      pieTotal: "",
      comChart: {},
      activeComChart: false,
      selectedProduct: "",
      productOptions: [],
      reviewStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      reviewEndDate: moment().format("YYYY-MM-DD"),
      reviewGraph: {},
      creviewGraph: {},
      activeReviewGraph: false,
      ratingGraph: {},
      cratingGraph: {},
      activeRatingGraph: false,
      totalReviewCount: "",
      ratingAvg: "",
      reviewStarData: {},
      sentimentData: {},
      sentimentChart: {},
      showBrand: true,
      activeSentimentChart: false,
      sovInterval: "day",
      sovStartDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
      sovEndDate: moment().format("YYYY-MM-DD"),
      revInterval: "month",
      selectedWebComplianceScore: "",
      brand_list: [],
      gpu_list: [],
      schProduct: "",
      itemCategory: [
        { key: "heaters", value: "Heaters" },
        { key: "fans", value: "Fans" },
        { key: "chimney", value: "Chimney" },
        { key: "purifiers", value: "Purifiers" },
        { key: "cooktop", value: "Cooktop" },
      ],
      filterCategory: [
        { key: "heaters", value: "Heaters" },
        { key: "fans", value: "Fans" },
        { key: "chimney", value: "Chimney" },
        { key: "purifiers", value: "Purifiers" },
        { key: "cooktop", value: "Cooktop" },
      ],
      filterBrand: [],
      selectedItemCategory: { key: "heaters", value: "Heaters" },
      client: JSON.parse(localStorage.reviewUserData).data.client,
      customClient: "hindware",
      selectedFilterCategory: "",
      selectedFilterBrand: "",
      dataType: "category",
      icChangeOccur: false,
      viewTableDataSummary: {},
      report: [
        { key: "most_reviewed", label: "Most Reviewed" },
        { key: "least_reviewed", label: "Least Reviewed" },
        { key: "top_reviewed", label: "Top Reviewed" },
        { key: "worst_reviewed", label: "Worst Reviewed" },
      ],
    };
  },
  watch: {
    sovInterval: function () {
      this.getTrendline();
      this.getDailyData();
    },
    revInterval: function () {
      if (this.selectedProduct) this.getReviews();
    },
    selected_website: function () {
      let self = this;
      console.log("called watch");
      if (self.selected_website == "https://www.flipkart.com") {
        self.itemCategory = [
          { key: "heaters", value: "Heaters" },
          { key: "fans", value: "Fans" },
          { key: "chimney", value: "Chimney" },
          { key: "purifiers", value: "Purifiers" },
          { key: "cooktop", value: "Cooktop" },
        ];
      } else {
        self.itemCategory = [
          { key: "heaters", value: "Heaters" },
          { key: "fans", value: "Fans" },
          { key: "chimney", value: "Chimney" },
          { key: "purifiers", value: "Purifiers" },
          { key: "cooktop", value: "Cooktop" },
        ];
      }
      localStorage.demo_selected_website = this.selected_website;
    },
  },
  mounted() {
    let self = this;
    localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
    // if(localStorage.philips_startDate) this.date.startDate = localStorage.philips_startDate
    // if(localStorage.philips_prevStartDate)  this.date.pStartDate = localStorage.philips_prevStartDate
    if (localStorage.demo_selected_website)
      this.selected_website = localStorage.demo_selected_website;

    if (self.selected_website == "https://www.flipkart.com") {
      self.itemCategory = [
        { key: "heaters", value: "Heaters" },
        { key: "fans", value: "Fans" },
        { key: "chimney", value: "Chimney" },
        { key: "purifiers", value: "Purifiers" },
        { key: "cooktop", value: "Cooktop" },
      ];
    } else {
      self.itemCategory = [
        { key: "heaters", value: "Heaters" },
        { key: "fans", value: "Fans" },
        { key: "chimney", value: "Chimney" },
        { key: "purifiers", value: "Purifiers" },
        { key: "cooktop", value: "Cooktop" },
      ];
    }

    if (localStorage.demo_selectedItemCategory) {
      this.selectedItemCategory = {};
      for (let [i, k] of this.itemCategory.entries()) {
        if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
          this.selectedItemCategory = k;
        }
      }
      if (!Object.keys(this.selectedItemCategory).length) {
        this.selectedItemCategory = this.itemCategory[0];
      }
    } else self.selectedItemCategory = this.itemCategory[0];

    if (this.selectedItemCategory.key == "heaters") {
      this.selectedFilterCategory = "heaters";
    } else {
      this.selectedFilterCategory = this.selectedItemCategory.key;
    }

    console.log(self.selectedItemCategory);
    this.clientMapper = {
      brand: this.client,
      "non-brand": "Non-" + this.client,
    };
    this.reviewStartDate = moment()
      .subtract(1, "year")
      .startOf("year")
      .format("YYYY-MM-DD");
    this.reviewEndDate = this.date.startDate;
    this.sovStartDate = moment(this.date.pStartDate).format("YYYY-MM-DD");
    this.sovEndDate = this.date.startDate;
    this.refresh();
  },
  methods: {
    refresh0() {
      self = this;
      if (!self.icChangeOccur) {
        this.selectedItemCategory = { key: "heaters", value: "Heaters" };
        this.selectedFilterCategory = "heaters";
        localStorage.demo_selectedItemCategory = JSON.stringify(
          this.selectedItemCategory
        );
      }
      self.icChangeOccur = false;
      this.refresh();
    },
    icChanged() {
      this.icChangeOccur = true;
      if (this.selectedItemCategory.key == "heaters") {
        this.selectedFilterCategory = "heaters";
      } else {
        this.selectedFilterCategory = this.selectedItemCategory.key;
      }
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.refresh0();
    },
    changeCategory() {
      this.getPie();
      this.getReport();
    },
    changeSOVandTrendDate() {
      this.getTrendline();
      this.getDailyData();
    },
    selectProductNow(d) {
      let self = this;
      self.selectedProduct = d;
      self.refreshReview();
      self.isProductModal = false;
    },
    showProductModal() {
      let self = this;
      self.isProductModal = true;
    },
    goToCompliance() {
      let self = this;
      localStorage.selectedWebComplianceScore = self.selectedWebComplianceScore;
      window.location = "#/compliance-detail";
    },
    formatDate(key, d) {
      let self = this;
      let obj = {
        day: moment(d).format("MMM DD, YY"),
        month: moment(d).format("MMM YY"),
        week: "",
      };
      if (self[key] == "week") {
        let end_date = moment(d).add(6, "days");
        let today = moment(self.date.startDate);
        if (end_date >= today) end_date = today;
        obj["week"] =
          moment(d).format("MMM DD, YY") + " - " + moment(end_date).format("MMM DD, YY");
      }
      return obj[this[key]];
    },
    getReport() {
      let self = this;
      self.viewTableDataSummary = {};
      self.loader = true;
      let payload = {
        client: "hindware",
        item_category: self.selectedItemCategory.key,
        website: self.selected_website,
        data_type: self.dataType,
        timestamp: self.date.startDate,
      };
      const url = "/api/india_clients/reviews_table_data";
      this.$http.post(url, payload).then(
        (response) => {
          self.viewTableDataSummary = response.data.data;
          self.loader = false;
        },
        (err) => {
          console.log(err);
          self.loader = false;
        }
      );
    },
    drawReviewGraph(reviewData) {
      let self = this;
      self.totalReviewCount = reviewData.count;
      let revRat = [
        {
          label: "Review",
          key: "review_count",
          graph: "reviewGraph",
          active: "activeReviewGraph",
        },
        {
          label: "Rating",
          key: "rating",
          graph: "ratingGraph",
          active: "activeRatingGraph",
        },
        {
          label: "Cummulative Review",
          key: "commulative_review_count",
          graph: "creviewGraph",
          active: "activeReviewGraph",
        },
        {
          label: "Cummulative Rating",
          key: "commulative_rating",
          graph: "cratingGraph",
          active: "activeReviewGraph",
        },
        // { label:'Rating', key:'rating', graph: 'ratingGraph', active: 'activeRatingGraph' }
      ];
      let sumRating = 0;
      for (let [idx, dataset] of reviewData.timeline.entries()) {
        sumRating += dataset.rating;
      }
      self.ratingAvg = sumRating / reviewData.timeline.length;
      self.ratingAvg = Math.round(self.ratingAvg);
      let y_labels = [
        "Review Count",
        "Avg. Rating",
        "Cummulative Review Count",
        "Cummulative Rating",
      ];
      let tick_arr = [50, 1];
      let max_arr = [undefined, 5];
      for (let [ii, rr] of revRat.entries()) {
        let cat = [];
        let data = [];
        for (let [idx, dataset] of reviewData.timeline.entries()) {
          cat.push(self.formatDate("revInterval", dataset.date));
          data.push(dataset[rr.key]);
        }
        self[rr.graph] = {
          chart: {
            type: "line",
            height: 180,
          },
          title: {
            text: "",
          },
          subtitle: {
            text: "",
          },
          xAxis: {
            categories: cat,
            title: {
              text: null,
            },
          },
          yAxis: {
            min: 0,
            tickInterval: tick_arr[ii],
            max: max_arr[ii],
            title: {
              text: y_labels[ii],
            },
          },
          tooltip: {
            formatter: function () {
              var mytooltip = this.key + "<br/>";

              mytooltip += '<span style="color:' + this.series.color + '">\u25CF</span> ';
              mytooltip += this.series.name;
              mytooltip += " : <b> " + self.format(this.y);

              mytooltip += "</b><br/>";

              return mytooltip;
            },
          },

          legend: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          series: [
            {
              name: rr.label,
              data: data,
              color: "#ffa500a8",
            },
          ],
        };
        if (rr.graph == "ratingGraph") self["ratingGraph"]["yAxis"]["min"] = 1;
        setTimeout(function () {
          self[rr.active] = true;
        }, 200);
      }
    },
    getReviews() {
      let self = this;
      self.loader = true;
      self.activeReviewGraph = false;
      let payload = {
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        interval: self.revInterval,
        client: self.customClient,
        // "item_category": self.selectedItemCategory.key
      };
      if (self.selected_website != "all") {
        payload["channel"] = self.websitesUrls[self.selected_website];
      }
      if (self.selectedProduct != "all") {
        payload["product_name"] = self.selectedProduct;
      }

      const url = "/api/india_clients/multi/review/hist";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.drawReviewGraph(response.body.data);
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    refreshReview() {
      let self = this;
      if (self.selectedProduct) self.getReviews();
    },

    goToDetailPage() {
      window.location = "#/sov-detailed-hindware";
    },
    goToReview() {
      window.location = "#/reviewslist-hindware";
    },
    drawDailyChart(d) {
      let self = this;
      let categories = [];
      let data3 = [];
      let data4 = [];
      let pageCount = "";
      let obj = {};
      for (let [idx, dataset] of d.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        let bsov = Math.round(dataset.brand_sov);
        let nbsov = Math.round(dataset.non_brand_sov);
        pageCount = dataset.page_count;
        data3.push(bsov);
        data4.push(nbsov);
      }
      console.log;
      self.daywiseChart = {
        chart: { type: "line", height: 230 },
        title: { text: "" },
        subtitle: { verticalAlign: "bottom", text: "Total Results: " + pageCount },
        xAxis: { categories: categories, title: { text: null } },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
              style: { fontWeight: 0 },
              formatter: function () {
                let category = this.point.category;
                let plotY = this.point.plotY;
                if (obj.hasOwnProperty(category)) obj[category].push(plotY);
                else {
                  obj[category] = [];
                  obj[category].push(plotY);
                }
                let plotYPos = obj[category].indexOf(plotY);
                let prvPlotY = obj[category][plotYPos - 1];
                if (plotYPos > 0) {
                  if (plotY - prvPlotY < 9 && plotY - prvPlotY > -9) {
                    this.point.plotY = this.point.plotY + 9;
                    obj[category][plotYPos] = this.point.plotY;
                  }
                }
                return this.point.y + "%";
              },
            },
          },
        },
        yAxis: { title: { text: "" } },
        tooltip: { shared: true },
        legend: { enabled: true },
        credits: { enabled: false },
        series: [
          {
            name: d[0]["brand"] + " SOV",
            data: data3,
            color: "#ffa500a8",
            tooltip: { valueSuffix: " %" },
          },
          {
            name: d[0]["non_brand"] + " SOV",
            data: data4,
            color: "grey",
            tooltip: { valueSuffix: " %" },
          },
        ],
      };
    },

    processCategorySearchGraph(d) {
      let self = this;
      let cat = d.category;
      let srch = d.search;
      let seriesData = [];
      let minPointLength = 0;
      let color = { 1: "#00800080", 2: "#ffa5008a", 3: "#ff00008a" };
      for (const [key, value] of Object.entries(cat)) {
        minPointLength += 5;
        let obj = {
          name: "Page " + key,
          data: [cat[key], srch[key]],
          color: color[key],
          borderWidth: 0,
          minPointLength: minPointLength,
        };
        seriesData.push(obj);
      }

      self.categorySearchGraph = {
        chart: {
          type: "column",
          height: 320,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          opposite: true,
          categories: [
            self.selectedItemCategory.value + " category page",
            self.selectedItemCategory.value + " search page",
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "",
          },
        },
        tooltip: {
          enabled: true,
          shared: true,
        },
        plotOptions: {
          column: {
            stacking: "percent",
            dataLabels: {
              enabled: true,
              useHTML: true,
              zIndex: 0,
              formatter: function () {
                return (
                  '<span style="color:white;font-size:10px;font-weight:normal;background-color:#00000085;padding:4px">' +
                  self.format(Number(this.point.percentage.toFixed())) +
                  "% </span>"
                );
              },
            },
          },
        },
        series: seriesData,
      };
    },

    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      var self = this;
      console.log("called refresh");

      self.loader0 = true;
      const url = "/api/india_clients/product_set_list";
      let payload = {
        client: "hindware",
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.loader0 = false;
          let resData = response.body.data;
          localStorage.demo_voc_product_list = JSON.stringify(resData.voc_product_list);

          this.sov();
          this.getDailyData();
          this.getPageDistribution();
          this.getTrendline();
          this.getPie();
          this.getProduct();
          this.getFilterBrand();
          this.getReport();
        },
        (err) => {
          self.loader0 = false;
        }
      );
    },
    getFilterBrand() {
      let self = this;
      self.loader4 = true;
      const url = "/api/india_clinets/get_brand_list_india_client";
      let payload = {
        channel: self.websitesUrls[self.selected_website],
        client: self.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader4 = false;
          self.filterBrand = response.data.data;
        },
        (err) => {
          self.loader4 = false;
        }
      );
    },
    getProduct() {
      var self = this;
      self.loader4 = true;
      const url = "/api/india_clients/multi/products_list";
      let payload = {
        channel: self.websitesUrls[self.selected_website],
        item_category: self.selectedFilterCategory,
        brand: self.selectedFilterBrand,
        client: self.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader4 = false;
          let resData = response.body.data;
          self.productOptions = resData;
          self.selectedProduct = self.productOptions[0];
          self.refreshReview();
        },
        (err) => {
          self.loader4 = false;
          console.log(err);
          console.log("err");
        }
      );
    },
    getPie() {
      var self = this;
      self.loader4 = true;
      const url = "/api/india_clients/product_brand_wheel";
      let payload = {
        website: self.selected_website,
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        item_category: self.selectedItemCategory.key,
        client: self.customClient,
        data_type: self.dataType,
        page: self.selectedPage,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader4 = false;
          let resData = response.body.data;
          self.createPie(resData);
        },
        (err) => {
          self.loader4 = false;
          console.log(err);
          console.log("err");
        }
      );
    },
    getTrendline() {
      var self = this;
      self.loader3 = true;
      const url = "/api/india_clients/product_sov_trendline";
      let payload = {
        website: self.selected_website,
        start_date: moment(self.sovStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.sovEndDate).format("YYYY-MM-DD"),
        item_category: self.selectedItemCategory.key,
        client: self.customClient,
        interval: self.sovInterval,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader3 = false;
          let resData = response.body.data.data;
          self.drawDailyChart(resData);
        },
        (err) => {
          self.loader3 = false;
          console.log(err);
          console.log("err");
        }
      );
    },
    getPageDistribution() {
      var self = this;
      self.loader2 = true;
      const url = "/api/india_clients/page_distribution";
      let payload = {
        website: self.selected_website,
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        item_category: self.selectedItemCategory.key,
        client: self.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader2 = false;
          let resData = response.body.data;
          self.processCategorySearchGraph(resData);
        },
        (err) => {
          self.loader2 = false;
          console.log(err);
          console.log("err");
        }
      );
    },
    sov() {
      let self = this;
      self.activeChart = false;
      self.loader = true;
      const url = "/api/india_clients/sov";
      let payload = {
        website: self.selected_website,
        start_date: self.date.pStartDate,
        end_date: self.date.startDate,
        item_category: self.selectedItemCategory.key,
        client: self.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          let resData = response.body.data;
          self.barSOVSOS(resData);
        },
        (err) => {
          self.loader = false;
          console.log(err);
          console.log("err");
        }
      );
    },
    barSOVSOS(d) {
      let self = this;
      this.rows = d.sov;
      this.sos_rows = d.sos;
      self.loader = false;
      self.$nextTick(function () {
        let xaxis = [];
        let data1 = [];
        let data2 = [];
        let data3 = [];
        let data4 = [];
        let max1 = 0;
        let max2 = 0;
        let limit = 9;
        let textCat =
          "Page 1 Count: <b>" +
          self.rows[0].page_1_count +
          "</b><br/>Pages 1-4 Count: <b>" +
          self.rows[0].page_1_3_count;
        let textSch =
          "Page 1 Count: <b>" +
          self.sos_rows[0].page_1_count +
          "</b><br/>Pages 1-4 Count: <b>" +
          self.sos_rows[0].page_1_3_count;

        for (let [idx, dataset] of self.columns.slice(3, limit).entries()) {
          if (
            dataset.field != "page_1_count" &&
            dataset.field != "page_all_count" &&
            dataset.field != "page_1_system_count" &&
            dataset.field != "page_all_system_count" &&
            dataset.field != "page_1_3_count" &&
            dataset.field != "page_1_3_system_count"
          ) {
            var d1 = Number(self.rows[0][dataset.field].toFixed());
            var d2 = Number(self.rows[1][dataset.field].toFixed());
            var d3 = Number(self.sos_rows[0][dataset.field].toFixed());
            var d4 = Number(self.sos_rows[1][dataset.field].toFixed());
            if (d1 >= max1) max1 = d1;
            if (d2 >= max1) max1 = d2;
            if (d3 >= max2) max2 = d3;
            if (d4 >= max2) max2 = d4;
            xaxis.push(dataset.label);
            data1.push(d1);
            data2.push(d2);
            data3.push(d3);
            data4.push(d4);
          }
        }
        self.charts = {
          credits: {
            enabled: false,
          },
          chart: {
            type: "column",
            height: 320,
            inverted: true,
          },
          title: {
            text: "",
          },
          subtitle: {
            align: "left",
            text: textCat,
          },
          yAxis: {
            title: {
              text: "",
            },
            max: max1 + 5,
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                color: "black",
                inside: false,
                formatter: function () {
                  return this.point.y + "%";
                },
              },
            },
          },
          xAxis: {
            categories: xaxis,
            crosshair: true,
          },
          tooltip: {
            formatter: function () {
              var mytooltip = this.points[0].key + "<br/>";
              for (var i = 0; i < this.points.length; i++) {
                mytooltip +=
                  '<span style="color:' +
                  this.points[i].series.color +
                  '">\u25CF</span> ';
                mytooltip += this.points[i].series.name;
                mytooltip += " : <b> " + self.format(this.points[i].y);
                if (this.points[0].key.indexOf("SOV") != -1) mytooltip += "%";
                mytooltip += "</b><br/>";
              }
              return mytooltip;
            },
            shared: true,
          },
          series: [
            {
              name: self.rows[0]["brand"],
              data: data1,
              color: "#3368fa8c",
              allData: self.rows[0],
            },
            {
              name: self.rows[1]["brand"],
              data: data2,
              color: "#833c808c",
              allData: self.rows[1],
            },
          ],
        };

        self.charts_sos = {
          credits: {
            enabled: false,
          },
          chart: {
            type: "column",
            height: 320,
            inverted: true,
          },
          title: {
            text: "",
          },
          subtitle: {
            align: "left",
            text: textSch,
          },

          yAxis: {
            title: {
              text: "",
            },
            max: max2 + 5,
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                color: "black",
                formatter: function () {
                  let mapper = {};
                  let d = this.series.userOptions.allData;
                  mapper["Page 1 SOV"] = d.page_1_system_count + "/" + d.page_1_count;
                  mapper["Pages 1-4 SOV"] =
                    d.page_1_3_system_count + "/" + d.page_1_3_count;
                  mapper["All Pages SOV"] =
                    d.page_all_system_count + "/" + d.page_all_count;
                  if (mapper[this.key]) return this.point.y + "%";
                  else return this.point.y;
                },
              },
            },
          },
          xAxis: {
            categories: xaxis,
            crosshair: true,
          },
          tooltip: {
            formatter: function () {
              var mytooltip = this.points[0].key + "<br/>";
              for (var i = 0; i < this.points.length; i++) {
                mytooltip +=
                  '<span style="color:' +
                  this.points[i].series.color +
                  '">\u25CF</span> ';
                mytooltip += this.points[i].series.name;
                mytooltip += " : <b> " + self.format(this.points[i].y);
                if (this.points[0].key.indexOf("SOV") != -1) mytooltip += "%";
                mytooltip += "</b><br/>";
              }
              return mytooltip;
            },
            shared: true,
          },
          series: [
            {
              name: self.sos_rows[0]["brand"],
              data: data3,
              color: "#3368fa8c",
              allData: self.sos_rows[0],
            },
            {
              name: self.sos_rows[1]["brand"],
              data: data4,
              color: "#833c808c",
              allData: self.sos_rows[1],
            },
          ],
        };
        $("#myTable").DataTable();
        self.activeChart = true;
      });
    },
    format(v) {
      return this.$options.filters.format(v);
    },
    createPie(brands) {
      let self = this;
      let color_codes = [
        "#78b2fb",
        "#cefb78",
        "#fb7878",
        "#b0e1ff",
        "#78eefb",
        "#91ce8e",
        "#59cdfb",
        "#fbd378",
        "#c139a4",
      ];
      let color_index = 0;
      let total = 0;
      let seriesData = [];
      for (let [i, d] of Object.entries(brands)) total += d;
      for (let [i, d] of Object.entries(brands)) {
        let obj = { name: i, y: d, total: total, color: color_codes[color_index] };
        if (color_index == color_codes.length - 1) color_index = 0;
        else color_index++;
        seriesData.push(obj);
      }
      self.pieChartAMD = {
        chart: {
          margin: [80, 0, 35, 0],
          padding: [0, 0, 0, 0],
        },
        title: {
          text:
            self.selectedItemCategory.value +
            "  Category Page (" +
            self.selectedPage +
            ") Distribution by Brand <br> Total Results: " +
            total,
          verticalAlign: "bottom",
          style: { fontSize: 13 },
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="font-size:22px;color:' +
              this.point.color +
              '">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip +=
              " : <b> " +
              self.format(this.point.y) +
              " (" +
              self.format(this.point.percentage.toFixed()) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                self.pieTotal = this.point.total;

                return (
                  '<span style="color:black;font-size:11px;font-weight:normal;">' +
                  self.format(this.point.percentage.toFixed()) +
                  "%</span>"
                );
              },
              distance: -13,
              style: {
                fontSize: 11,
              },
            },
            showInLegend: true,
            size: "100%",
          },
        },
        legend: {
          align: "center",
          layout: "horizontal",
          verticalAlign: "top",
          itemStyle: {
            fontSize: 11,
            fontWeight: 1,
          },
          maxHeight: 65,
        },
        series: [
          {
            type: "pie",
            data: seriesData,
          },
        ],
      };
      setTimeout(function () {
        self.activePie = true;
      }, 50);
    },
    changeCustomDate() {
      if (this.date.pStartDate)
        this.date.pStartDate = moment(this.date.pStartDate).format("YYYY-MM-DD");
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
      // localStorage.philips_startDate = this.date.startDate;
      // localStorage.philips_prevStartDate = this.date.pStartDate;
    },
    getDailyData() {
      let self = this;
      self.loader4 = true;
      self.daywiseAMDCount = {};
      const url = "/api/websites/daily_sov";
      let payload = {};
      payload["website"] = [];
      payload["item_category"] = self.selectedItemCategory.key;
      payload["timestamp"] = self.date.startDate;
      payload["interval"] = self.sovInterval;
      payload["start_date"] = moment(self.sovStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.sovEndDate).format("YYYY-MM-DD");
      if (self.selected_website == "all") {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx);
        }
      } else {
        payload["website"].push(self.selected_website);
      }
      self.$http.post(url, payload).then(
        (response) => {
          self.loader4 = false;
          self.drawDailyAMDCount(response.body.all_data);
        },
        (err) => {
          self.loader4 = false;
          console.log("err");
        }
      );
    },
    drawDailyAMDCount(d) {
      console.log("check data", d);
      let self = this;
      let categories = [];
      let data = [];
      let data2 = [];
      let data3 = [];
      let laptop_count = 0;
      for (let [idx, dataset] of d.entries()) {
        categories.push(self.formatDate("sovInterval", dataset.timestamp));
        data.push(dataset.amd_count);
        data2.push(dataset.all_count);
        data3.push(dataset.sov);
      }
      self.daywiseAMDCount = {
        chart: {
          type: "line",
          height: 230,
        },
        title: {
          text: "",
        },
        subtitle: {
          verticalAlign: "bottom",
          text: "",
        },
        xAxis: {
          categories: categories,
          title: {
            text: null,
          },
        },

        yAxis: [
          {
            min: 0,
            title: { text: "Count" },
          },
          {
            min: 0,
            title: { text: "Hindware SOS" },
            opposite: false,
          },
        ],
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y);
              if (this.points[i].series.name.indexOf("SOS") != -1) mytooltip += "%";
              mytooltip += "</b><br/>";
            }
            return mytooltip;
          },
          shared: true,
        },
        legend: {
          enabled: true,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Hindware " + self.selectedItemCategory.value,
            data: data,
            zIndex: 9,
            type: "bar",
            yAxis: 0,
          },
          {
            name: "All " + self.selectedItemCategory.value,
            data: data2,
            type: "bar",
            yAxis: 0,
          },
          {
            name: "Hindware SOS",
            data: data3,
            yAxis: 1,
            type: "line",
            pointWidth: 1,
            color: "#fb7878",
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.eachProduct:hover {
  background: #d4d4d4;
}
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important;
}
.markitintel {
  background-color: #c7e0ff !important;
}
.markitsnap {
  background-color: #ffd0f5 !important;
}
.markitna {
  background-color: #edf2fb !important;
}
.markittek {
  background-color: #fff0ce !important;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;

  padding-bottom: 5px;
}
.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}
.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}
.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}
.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}
.amd-legend i {
  width: fit-content;
}
.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}
.legending {
  display: inline-block;
  margin-right: 19px;
}
#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}
.mycol {
  padding-right: 15px !important;
  padding-left: 15px !important;
}
.mycols:first-child {
  padding-right: 2px !important;
}
.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff;
  background-color: #8a87e8;
  border-color: #8a87e8;
  height: 30px;
  border-radius: 0;
}
.btn-outline-secondary {
  height: 30px;
  border-radius: 0;
  line-height: 17px;
  background: white;
}
.sovdetails {
  float: right;
  height: 30px;
  margin: 0;
  border-radius: 0;
  font-size: 15px;
  padding: 7px;
  width: max-content;
  cursor: pointer;
  margin-left: 4px;
}
.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}
.tr {
  text-transform: none;
  font-family: sans-serif;
  font-weight: bolder;
  /* text-align: left; */
  border: 1px solid silver !important;
  background: #edddcd;
}
/* table {
  width: max-content !important;
} */
/* table th,
table td {
  width: 200px;
} */
td:first-child {
  background-color: #f3f3ff;
}
.custom-hr-scroll {
  overflow-x: scroll !important;
}
</style>
